document.addEventListener( 'DOMContentLoaded', function() {

  function SlideNumber( Splide, Components ) {
    const { track } = Components.Elements;
  
    let elm;
  
    function mount() {
      elm = document.createElement( 'div' );
      elm.classList.add('splide__pagenumber');
      elm.style.textAlign = 'center';
  
      track.parentElement.insertBefore( elm, track.nextSibling );
  
      update();
      Splide.on( 'move', update );
    }
  
    function update() {
      elm.textContent = `${ Splide.index + 1 }/${ Splide.length }`;
    }
  
    return {
      mount,
    };
  }

  if (document.querySelector('.p-product-id .splide')) {
    new Splide('.p-product-id .splide').mount({
      // .p-product-id専用のオプションや拡張機能
      SlideNumber,
    } )

  }

  if (document.querySelector('.p-top .splide')) {
    new Splide('.p-top .splide', {
      type: 'loop',
      autoplay: 'play',
      perPage: 1,
      interval: 5000,
      speed: 3000,
      // p-top専用のオプション
    }).mount();
  }

})